/*@ngInject*/
export default ['Users', '$q', 'ASYNC_VALIDATOR_DEBOUNCE', (Users, $q, ASYNC_VALIDATOR_DEBOUNCE) => ({
    restrict: 'AE',
    require: 'ngModel',
    link: (scope, elm, attrs, ctrl) => {
        ctrl.$options.$$options.updateOn = 'default blur';
        ctrl.$options.$$options.debounce = {default: ASYNC_VALIDATOR_DEBOUNCE, blur: 0};

        ctrl.$asyncValidators.unique = (modelValue) => {
            let def = $q.defer();
            Users.exists({email: modelValue},
                (res) => {
                    if (!res.exists) {
                        def.resolve();
                    } else {
                        def.reject();
                    }
                });

            return def.promise;
        };
    }
})];
